import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cca2b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "brush-map__buttons"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 5. Сохранить ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 5. Изменить ")
const _hoisted_4 = {
  key: 0,
  class: "brush-map__current-color"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Текущий цвет:", -1))

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import BrushMapSelectColor from './components/BrushSelectColor/BrushMapSelectColor.vue'
import { useOrganizationModules } from '@/shared/composables'
import { BrushMapTeeth } from '@/pages/BrushMapPage/brushMapTeeth'
import BrushMapSelectFirm from '@/pages/BrushMapPage/components/BrushMapAside/components/BrushMapSelectFirm.vue'
import BrushMapSelectTooth from '@/pages/BrushMapPage/components/BrushMapAside/components/BrushMapSelectTooth.vue'
import BrushMapSelected from '@/pages/BrushMapPage/components/BrushMapSelected.vue'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { BrushMapFirm } from '../../brushMapFirm'
import { BrushMapController } from '../../brushMapController'

interface Props {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
  brushMapFirm: BrushMapFirm
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapTeeth: null,
    brushMapBrushes: null,
    brushMapController: null,
    brushMapFirm: null
  },
  emits: ['sendReport', 'updateReport'],
  setup(__props: any, { emit }) {

const props = __props as {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapController: BrushMapController
  brushMapFirm: BrushMapFirm
}




const route = useRoute()
const isCreationPage = computed(() => route.params.reportId === '0')
const selectedColor = computed(() => props.brushMapBrushes.selectedBrush)
const isModalVisible = ref(false)
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const sendReport = () => {
  emit('sendReport')
  isModalVisible.value = true
}

const updateReport = () => {
  emit('updateReport')
  isModalVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["brush-map__aside", { 'brush-map__aside_preview': _unref(isPreviewMode) }])
    }, [
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(BrushMapSelectTooth),
            _createVNode(BrushMapSelectFirm, {
              "brush-map-controller": __props.brushMapController,
              "brush-map-firm": __props.brushMapFirm
            }, null, 8, ["brush-map-controller", "brush-map-firm"]),
            _createVNode(BrushMapSelectColor, {
              "brush-map-firm": __props.brushMapFirm,
              "brush-map-teeth": __props.brushMapTeeth,
              "brush-map-brushes": __props.brushMapBrushes
            }, null, 8, ["brush-map-firm", "brush-map-teeth", "brush-map-brushes"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(BrushMapSelected, {
        "brush-map-firm": __props.brushMapFirm,
        "brush-map-controller": __props.brushMapController,
        "brush-map-teeth": __props.brushMapTeeth,
        "brush-map-brushes": __props.brushMapBrushes
      }, null, 8, ["brush-map-firm", "brush-map-controller", "brush-map-teeth", "brush-map-brushes"]),
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(isCreationPage))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  round: "",
                  type: "primary",
                  onClick: sendReport
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  round: "",
                  type: "primary",
                  onClick: updateReport
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (!_unref(isPreviewMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            style: _normalizeStyle({ background: _unref(selectedColor).color })
          }, null, 4),
          _createElementVNode("p", null, _toDisplayString(_unref(selectedColor).colorName), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})